// extracted by mini-css-extract-plugin
export default {"tumbleweed":"#dab177","content":"BS","header":"BT","image":"BU","link":"BV","link-wrapper":"BW","linkWrapper":"BW"};